export enum MessageType {
    Success,
    Warning,
    Error,
    Information,
}